export default {
  id: "65ff7711-e52c-405c-9ba5-2c86c380c397",
  icon: "mdi-message-question",
  name: "adaptiveLearningResult",
  title: "Adaptive Learning Results",
  description: "Adaptive Learning Results block"
}
